<template>
  <ClientOnly>
    <AiSearchBarClient
      :ai-advisor="props.aiAdvisor"
      :mobile="props.mobile"
      :search-url="searchUrl"
    />
  </ClientOnly>
</template>
<script setup lang="ts">
import type { HeaderAiAdvisor } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
import AiSearchBarClient from './AiSearchBarClient.vue';

const props = withDefaults(
  defineProps<{
    mobile?: boolean;
    aiAdvisor: HeaderAiAdvisor;
  }>(),
  {
    mobile: false,
  }
);

const { getResolvedInternalLinkRef } = useRefsStore();

let searchUrl = '';
const searchLink = props.aiAdvisor.searchLink?.link;
if (searchLink && searchLink.length > 0) {
  const link = searchLink[0];
  if (
    link &&
    link._type === 'internalLink' &&
    'selectedPage' in link &&
    link.selectedPage?.reference?._ref
  ) {
    const resolvedInternalLink = await getResolvedInternalLinkRef(link.selectedPage.reference._ref);
    searchUrl = resolvedInternalLink?.value?.currentPathname || '';
  } else if (link && link._type === 'externalLink' && 'url' in link && link.url) {
    searchUrl = link.url;
  }
}
</script>
